export * from './angularfire2';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /Users/maikelbald/laboratorio/NossaCidadeMelhor/angular-app/~/angularfire2/index.js
// module id = ../../../../angularfire2/index.js
// module chunks = 7